var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithlessColorfullBigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 90,
    viewBox: "0 0 301 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.544 59.3527H119.641L125.194 40.9128L130.747 59.3527H135.844L145.25 30.163H138.827L133.233 48.4789L127.763 30.163H122.666L117.196 48.4376L111.602 30.163H105.138L114.544 59.3527Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.622 35.9404V59.3527H154.127V35.9404H147.622Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.785 30.163H156.623V35.8273H165.781V59.3527H172.287V35.8273H181.445V30.163H172.283V35.8263H165.785V30.163Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.94 59.3527H190.446V47.1559H202.049V59.3527H208.596V30.163H202.049V41.5329H190.446V30.163H183.94V59.3527Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.039 53.6487H219.544V59.3527H232.516V53.6471H219.545V30.163H213.039V53.6487Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.145 59.3527H241.636V53.7364H235.135V30.163H255.938V35.7446H241.641V41.7397H254.695V47.1559H241.641V53.7298H256.145V59.3527Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.508 59.8075C274.553 59.8075 278.738 56.4586 278.738 50.877C278.738 40.2512 265.022 42.7733 265.022 37.6878C265.022 36.0754 266.39 35.2071 268.71 35.2071C270.948 35.2071 272.688 36.0754 274.429 37.8945L278.655 33.7187C276.459 31.2793 272.937 29.7082 268.834 29.7082C262.784 29.7082 258.558 32.9331 258.558 38.308C258.558 48.5616 272.274 45.9569 272.274 51.4558C272.274 53.1923 270.658 54.2673 267.923 54.2673C264.856 54.2673 262.66 53.0683 260.795 50.877L256.569 55.0528C259.428 58.2778 262.701 59.8075 267.508 59.8075Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M289.77 59.8075C296.815 59.8075 301 56.4586 301 50.877C301 40.2512 287.284 42.7733 287.284 37.6878C287.284 36.0754 288.651 35.2071 290.972 35.2071C293.21 35.2071 294.95 36.0754 296.69 37.8945L300.917 33.7187C298.721 31.2793 295.199 29.7082 291.096 29.7082C285.046 29.7082 280.819 32.9331 280.819 38.308C280.819 48.5616 294.536 45.9569 294.536 51.4558C294.536 53.1923 292.919 54.2673 290.185 54.2673C287.118 54.2673 284.922 53.0683 283.057 50.877L278.83 55.0528C281.69 58.2778 284.963 59.8075 289.77 59.8075Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.1017,
    y: 22.275,
    width: 45.1017,
    height: 18,
    fill: "#32DCDC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 49.3594,
    width: 45.1017,
    height: 18,
    fill: "#3AF2AE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5508,
    y: 45,
    width: 45,
    height: 18.0407,
    transform: "rotate(-90 22.5508 45)",
    fill: "#40B0D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.6119,
    y: 90,
    width: 45,
    height: 18.0407,
    transform: "rotate(-90 49.6119 90)",
    fill: "#5CFFE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithlessColorfullBigLogo);
export default __webpack_public_path__ + "static/media/withless-colorfull-big-logo.eb452baa6d3908db9ecd7c405ae3421f.svg";
export { ForwardRef as ReactComponent };